
export default {
  vessel: {
    title: {
      fontSize: 'xl',
      lg: {
        fontSize: '3xl'
      }
    }
  },
  async fetch() {
    const { $content, $i18n: { locale } } = this
    this.page = await $content(locale, 'pages/about').fetch()
  },
  data() {
    return {
      page: null
    }
  },
  computed: {
    attachments() {
      const images = this.page.images
      const items = []

      images.forEach((item) => {
        items.push({
          src: item,
          title: this.page.title,
          fit: 'cover'
        })
      })

      return items
    }
  }
}
